import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Search, CornerDownLeft } from "lucide-react";
import { AuthContext } from "../App";
import { empresaTieneModulo } from "../lib/modulosEmpresa";

// Índice estático: [título, ruta, permiso(s) (any), módulo empresa, palabras clave, grupo]
const I = (titulo, ruta, perm, modulo, kw, grupo) => ({ titulo, ruta, perm, modulo, kw: kw || "", grupo });
const INDICE = [
  // Ventas
  I("Facturas", "/sistema/ventas?tab=facturas", ["facturas.ver"], null, "venta emitir cobrar pagar timbrado boleta contado credito", "Ventas"),
  I("Presupuestos", "/sistema/ventas?tab=presupuestos", ["presupuestos.ver"], null, "cotizacion proforma", "Ventas"),
  I("Recepción de Equipos", "/sistema/ventas?tab=recepcion", ["presupuestos.recepcion_ver"], null, "taller servicio tecnico equipo", "Ventas"),
  I("Entregas pendientes (ventas)", "/sistema/ventas?tab=entregas", ["entregas.ver"], null, "despacho entrega posterior mercaderia", "Ventas"),
  I("Ingresos varios", "/sistema/ventas?tab=ingresos", ["ingresos_varios.ver"], null, "ingreso vale cliente", "Ventas"),
  I("Recibos", "/sistema/ventas?tab=recibos", ["recibos.ver"], null, "recibo cobro", "Ventas"),
  I("Notas de crédito", "/sistema/ventas?tab=notas", ["notas_credito.ver"], null, "devolucion nc anular", "Ventas"),
  I("Configuración de Ventas", "/sistema/ventas?tab=configuracion", ["configuracion_ventas.ver", "facturas.ver", "presupuestos.ver"], null, "timbrado impresion automatica vendedores comision descuentos tipos de factura cobro automatico contado punto expedicion maximo items", "Ventas"),
  I("Timbrado (configuración)", "/sistema/ventas?tab=configuracion", ["configuracion_ventas.gestionar_timbrado"], null, "timbrado numeracion huecos autoimpresor preimpreso nota credito rango", "Ventas"),
  I("Cobro automático de ventas al contado", "/sistema/ventas?tab=configuracion", ["configuracion_ventas.gestionar_cobro_contado"], null, "contado pagar al registrar", "Ventas"),
  I("Punto de Venta (PDV)", "/sistema/pdv", ["pdv.ver"], null, "caja ticket mostrador escaner", "Ventas"),
  // Egresos
  I("Compras", "/sistema/egresos?tab=compras", ["compras.ver"], null, "proveedor factura compra cuotas recepcion", "Egresos"),
  I("Gastos / Costos fijos", "/sistema/egresos?tab=costos", ["costos_fijos.ver"], null, "gasto alquiler servicios vencimiento pagos", "Egresos"),
  I("Sueldos", "/sistema/egresos?tab=sueldos", ["empleados.ver"], null, "empleados salario pago sueldo descuento deuda adelanto extras", "Egresos"),
  I("Pago de IVA", "/sistema/egresos?tab=pago-iva", ["balance.ver", "pago_iva.ver"], null, "iva dnit liquidacion ajuste", "Egresos"),
  I("Anticipos", "/sistema/egresos?tab=anticipos", ["compras.ver", "empleados.ver"], null, "anticipo adelanto", "Egresos"),
  I("Mercaderías por recibir", "/sistema/egresos?tab=recepcion", ["entregas.ver", "compras.ver"], null, "recepcion nota recepcion compra pendiente", "Egresos"),
  // Financiero
  I("Transferencias", "/sistema/financiero?tab=transferencias", ["transferencias.ver"], null, "movimiento entre cuentas", "Financiero"),
  I("Cuentas bancarias y cajas", "/sistema/financiero?tab=cuentas", ["bancos.ver"], null, "banco caja saldo cuenta", "Financiero"),
  I("Pagos a proveedores", "/sistema/financiero?tab=pagos_proveedores", ["pagos_proveedores.ver"], null, "pagar proveedor comprobante", "Financiero"),
  I("Cheques", "/sistema/financiero?tab=cheques", ["cheques.ver", "bancos.ver"], null, "talonario emitir cheque diferido", "Financiero"),
  I("Préstamos", "/sistema/financiero?tab=prestamos", ["prestamos.ver", "bancos.ver"], null, "prestamo cuotas desembolso", "Financiero"),
  I("Garantías", "/sistema/financiero?tab=garantias", ["garantias.ver"], null, "garantia protocolo entrega", "Financiero"),
  I("Cotizaciones (tipo de cambio)", "/sistema/financiero?tab=cotizaciones", ["transferencias.ver", "bancos.ver"], null, "tc dolar usd brl real moneda", "Financiero"),
  I("Traspaso de saldos", "/sistema/financiero?tab=traspaso_saldos", ["financiero.traspasar_saldos"], null, "traspaso plan cuentas", "Financiero"),
  I("Programación de Caja", "/sistema/financiero?tab=programacion_caja", ["financiero.programacion_caja"], null, "programar pagos lote vencimientos", "Financiero"),
  I("Restricción de fechas de movimientos", "/sistema/financiero?tab=configuracion", ["transferencias.ver", "bancos.ver"], null, "fecha restringida bloquear periodo", "Financiero"),
  I("Balance", "/sistema/balance", ["balance.ver"], null, "balance gerencial iva resultado morosidad kpi", "Financiero"),
  I("Plan de Cuentas", "/sistema/plan-cuentas", ["plan_cuentas.ver"], null, "cuenta contable vencimiento fijo", "Financiero"),
  // Inventario
  I("Productos (catálogo)", "/sistema/productos", ["inventario_productos.ver"], null, "mercaderia articulo precio costo codigo barras etiqueta variante imagen", "Inventario"),
  I("Inventario técnico", "/sistema/inventario", ["inventario.ver"], null, "activos chasis equipos", "Inventario"),
  I("Historial de stock", "/sistema/historial-stock", ["historial_stock.ver"], null, "kardex movimientos stock ajuste", "Inventario"),
  // Catastro
  I("Catastro (clientes, proveedores, empleados)", "/sistema/catastro", ["empresas.ver", "proveedores.ver", "empleados.ver"], null, "cliente proveedor empleado entidad ruc ci chofer localidad huella", "Catastro"),
  // Reportes y control
  I("Reportes", "/sistema/reportes", ["reportes.ver"], null, "informe libro ventas estado de cuenta cuentas a pagar cobrar movimientos caja banco comisiones vendedores balancete stock vencimiento gastos categoria transporte loteadora iva", "Reportes"),
  I("Auditoría", "/sistema/auditoria", ["auditoria.ver"], null, "log usuarios activos sesiones historial acciones", "Administración"),
  I("Usuarios y permisos", "/sistema/usuarios", ["usuarios.ver"], null, "permisos roles accesos usuario", "Administración"),
  I("Configuración global", "/sistema/config-global", ["configuracion_global.ver"], null, "inactividad sesion minutos", "Administración"),
  I("Mis empresas", "/sistema/empresas-propias", null, null, "empresa propia logo modulos wipe base de datos nombre fantasia", "Administración", true),
  I("Licencias", "/sistema/licencias", null, null, "licencia renovacion aviso facturar", "Administración", true),
  I("Soporte", "/sistema/soporte", ["soporte.ver"], null, "ticket adjunto", "Administración"),
  I("Mi perfil", "/sistema/perfil", null, null, "contraseña password perfil", "Administración"),
  // Módulos de rubro
  I("Producción", "/sistema/produccion", ["produccion.ver"], "produccion", "pedido etapas kds cocina", "Rubros"),
  I("Hotelería", "/sistema/hoteleria", ["hoteleria.ver_panel"], "hoteleria", "habitaciones reservas hotel", "Rubros"),
  I("Loteadora", "/sistema/loteadora", ["loteadora.ver"], "loteadora", "lote manzana cuotas traspaso refinanciacion", "Rubros"),
  I("Transporte", "/sistema/transporte", ["transporte.ver"], "transporte", "orden de carga chofer flete vehiculo", "Rubros"),
  I("Taller", "/sistema/taller", ["taller.ver"], "taller", "orden de trabajo ot mecanico repuesto mantenimiento vehiculo preventivo", "Rubros"),
  I("Restaurante", "/sistema/restaurante", ["restaurante.ver"], "restaurante", "salon mesa comanda tarjeta", "Rubros"),
  I("Báscula", "/sistema/bascula", ["bascula.ver"], "bascula", "pesaje peso descuento", "Rubros"),
  I("Configuración de Equipos / Báscula", "/sistema/equipos-bascula", ["equipos_bascula.ver"], "equipos_bascula", "balanza serial tcp puerto com equipo", "Rubros"),
  I("Clínica / Fisioterapia", "/sistema/clinica", ["clinica_agenda.ver"], "clinica", "clinica fisioterapia paciente turno agenda expediente profesional comision", "Rubros"),
  I("Recetario agronómico", "/sistema/recetario", ["recetario.ver"], "recetario", "receta agronomica orden aplicacion ingeniero chacra agroquimico", "Rubros"),
  I("Constructora", "/sistema/constructora", ["constructora_proyectos.ver"], "constructora", "obra proyecto", "Rubros"),
  I("Lectura de bombas", "/sistema/lectura-bombas", ["lectura_bombas.ver", "lectura_bombas.configurar"], null, "surtidor combustible bomba", "Rubros"),
];

const norm = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

export default function GlobalSearch() {
  const auth = useContext(AuthContext) || {};
  const { user, hasPermission, activeEmpresaPropia } = auth;
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(0);
  const inputRef = useRef(null);
  const [right, setRight] = useState(24);

  // Posición automática: arriba a la derecha, corriéndose a la izquierda si hay otro botón/icono en ese lugar
  useEffect(() => {
    const SIZE = 36, TOP = 12, STEP = 44;
    const ocupado = (r) => {
      const xs = [window.innerWidth - r - SIZE + 4, window.innerWidth - r - SIZE / 2, window.innerWidth - r - 4];
      const ys = [TOP + 4, TOP + SIZE / 2, TOP + SIZE - 4];
      for (const x of xs) for (const y of ys) {
        for (const el of document.elementsFromPoint(x, y)) {
          if (el.closest("[data-global-search]")) continue;
          if (el.closest("button,a,input,select,textarea,[role=button]")) return true;
        }
      }
      return false;
    };
    const calc = () => {
      let r = 24;
      for (let i = 0; i < 20 && ocupado(r); i++) r += STEP;
      setRight((prev) => (prev === r ? prev : r));
    };
    calc();
    const t = setInterval(calc, 700);
    window.addEventListener("resize", calc);
    return () => { clearInterval(t); window.removeEventListener("resize", calc); };
  }, [location.pathname, location.search]);

  const esAdmin = ["admin", "super_admin"].includes(user?.role);

  const permitidos = useMemo(() => INDICE.filter((it) => {
    if (it.admin && !esAdmin) return false;
    if (it.modulo && activeEmpresaPropia && !empresaTieneModulo(activeEmpresaPropia, it.modulo)) return false;
    if (it.perm && hasPermission && !it.perm.some((p) => hasPermission(p))) return false;
    return true;
  }), [user, activeEmpresaPropia]); // eslint-disable-line

  const resultados = useMemo(() => {
    const terms = norm(q).split(/\s+/).filter(Boolean);
    if (!terms.length) return permitidos.slice(0, 12);
    return permitidos.filter((it) => {
      const txt = norm(`${it.titulo} ${it.grupo} ${it.kw}`);
      return terms.every((t) => txt.includes(t));
    }).slice(0, 15);
  }, [q, permitidos]);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setOpen((o) => !o); }
      else if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  useEffect(() => { if (open) { setQ(""); setSel(0); setTimeout(() => inputRef.current?.focus(), 30); } }, [open]);
  useEffect(() => { setSel(0); }, [q]);

  if (!user || !location.pathname.startsWith("/sistema")) return null;

  const ir = (it) => { setOpen(false); navigate(it.ruta); };
  const onInputKey = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setSel((s) => Math.min(s + 1, resultados.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setSel((s) => Math.max(s - 1, 0)); }
    else if (e.key === "Enter" && resultados[sel]) ir(resultados[sel]);
  };

  return (
    <>
      <button
        data-global-search
        onClick={() => setOpen(true)}
        title="Buscar en el sistema (Ctrl+K)"
        style={{ right }}
        className="fixed top-3 z-[60] w-9 h-9 flex items-center justify-center rounded-full bg-arandu-dark-light border border-white/15 text-gray-300 hover:text-white hover:border-arandu-primary shadow-lg"
      >
        <Search size={16} />
      </button>
      {open && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-start justify-center pt-24 px-4" onMouseDown={() => setOpen(false)}>
          <div className="w-full max-w-xl bg-arandu-dark-light border border-white/15 rounded-xl shadow-2xl overflow-hidden" onMouseDown={(e) => e.stopPropagation()}>
            <div className="flex items-center gap-2 px-4 py-3 border-b border-white/10">
              <Search size={18} className="text-gray-400" />
              <input
                ref={inputRef} value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={onInputKey}
                placeholder="¿Qué buscás? Ej: timbrado, sueldo, cheque, stock, permisos..."
                className="flex-1 bg-transparent outline-none text-white placeholder-gray-500 text-sm"
              />
              <kbd className="text-[10px] text-gray-400 border border-white/15 rounded px-1">Esc</kbd>
            </div>
            <div className="max-h-96 overflow-y-auto py-1">
              {resultados.length === 0 && <div className="px-4 py-6 text-center text-sm text-gray-400">Sin resultados</div>}
              {resultados.map((it, i) => (
                <button key={it.titulo + it.ruta} onClick={() => ir(it)} onMouseEnter={() => setSel(i)}
                  className={`w-full flex items-center justify-between gap-3 px-4 py-2 text-left text-sm ${i === sel ? "bg-arandu-primary/20 text-white" : "text-gray-300"}`}>
                  <span>{it.titulo}</span>
                  <span className="flex items-center gap-2 text-xs text-gray-500">{it.grupo}{i === sel && <CornerDownLeft size={12} />}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
